import React from "react";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Marcus T.",
    city: "Medford, OR",
    rating: 5,
    text: "My truck was in rough shape after a long Forest Service season. They came out to my house, spent the whole afternoon on it, and honestly it looks better than the day I bought it. Absolutely worth every penny.",
    service: "Full Detail",
  },
  {
    name: "Jessica R.",
    city: "Ashland, OR",
    rating: 5,
    text: "The interior on my 4Runner came out fantastic. Professional from start to finish, easy booking, and fair pricing. Already have my next appointment on the books.",
    service: "Full Detail",
  },
  {
    name: "Diego P.",
    city: "Grants Pass, OR",
    rating: 5,
    text: "Best interior detail I've ever had. Every bit of dog hair and kid mess is gone. The car smells brand new and feels like it too.",
    service: "Interior Detail",
  },
  {
    name: "Karen H.",
    city: "Central Point, OR",
    rating: 5,
    text: "Locally owned and it shows. They genuinely cared about the work, walked me through everything, and the car looks incredible. Couldn't be happier with the results.",
    service: "Exterior Detail",
  },
  {
    name: "Sandra B.",
    city: "Talent, OR",
    rating: 5,
    text: "Booked the interior detail for my minivan after two summers of soccer practice and hauling the kids around. Felt like a brand new car when I got it back.",
    service: "Interior Detail",
  },
  {
    name: "Wyatt C.",
    city: "Eagle Point, OR",
    rating: 5,
    text: "Showed up right on time. Did exactly what they promised. My truck has never looked cleaner. Highly recommend.",
    service: "Exterior Detail",
  },
];

export default function Testimonials() {
  return (
    <section id="reviews" data-testid="testimonials-section" className="py-20 md:py-24 bg-white">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-8 mb-16 items-end">
          <div className="md:col-span-7">
            <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-blue-600 mb-4">
              Customer Reviews
            </div>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
              Trusted across<br />the Rogue Valley.
            </h2>
          </div>
          <div className="md:col-span-5 flex md:justify-end">
            <div className="flex items-center gap-5">
              <div>
                <div className="flex items-center gap-1 text-blue-600 mb-1">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={18} fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
                <div className="font-display font-black text-3xl text-slate-900">5.0 / 5.0</div>
              </div>
              <div className="h-12 w-px bg-slate-300" />
              <div>
                <div className="font-display font-black text-3xl text-slate-900">150+</div>
                <div className="text-xs uppercase tracking-wider text-slate-500">Happy customers</div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              data-testid={`review-${i}`}
              className="bg-white p-6 md:p-7 flex flex-col justify-between hover:bg-slate-50 transition-colors"
            >
              <div>
                <Quote size={22} strokeWidth={2} className="text-blue-600 mb-4" />
                <p className="text-slate-700 leading-relaxed text-sm">{r.text}</p>
              </div>
              <div className="mt-6 pt-4 border-t border-slate-200">
                <div className="flex items-center gap-1 text-blue-600 mb-2">
                  {[...Array(r.rating)].map((_, idx) => (
                    <Star key={idx} size={12} fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
                <div className="font-display font-black text-base">{r.name}</div>
                <div className="text-xs uppercase tracking-wider text-slate-500">
                  {r.city} · {r.service}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
